import React from 'react'
import Navbar from '../defaultComponents/Navbar.jsx'
import Footer from '../defaultComponents/Footer.jsx'
import Iframe from 'react-iframe'
import {
  useNavigate
} from "react-router-dom";

export default function DeviceDetailsUpdateMobile() {
    const FORM_URL = "https://form.jotform.com/231147723904858";
    const navigate = useNavigate()

    const goBack = () => {
      navigate('/HR/deviceDetails')
    }
    return (
      <>
        <Navbar/>
        <div className="all-page-background" style={{background: "#F8F8F8", width: "100%", height: "100%"}}>
          <div className="jotform-wrapper">
          <Iframe url={FORM_URL} height="700px" width="100%" frameBorder="0"/>
          <div className="go-back-button device-page-button" onClick={goBack}>back</div>
          </div>
        
        <Footer/>
        </div>
      </>
    )
}
